import { splitPhone } from "./phone";

/** ₹3,42,600 — Indian digit grouping, whole rupees. */
export function inr(n: number): string {
  return "₹" + Math.round(n).toLocaleString("en-IN");
}

export function plural(n: number, one: string, many = one + "s"): string {
  return `${n} ${n === 1 ? one : many}`;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const chars = parts.length === 1 ? [...parts[0]].slice(0, 2) : [[...parts[0]][0], [...parts[parts.length - 1]][0]];
  return chars.join("").toUpperCase();
}

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}

/**
 * Indian mobile numbers are the identity key. Normalise to E.164 so
 * "98110 44821", "+91-98110-44821" and "0981104 4821" all match one guest.
 */
export function normalizePhone(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const hasPlus = trimmed.startsWith("+");
  let digits = trimmed.replace(/\D/g, "");
  if (!digits) return null;
  if (hasPlus) return digits.length >= 8 && digits.length <= 15 ? "+" + digits : null;
  if (digits.startsWith("00")) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  if (digits.length === 10) return "+91" + digits;
  if (digits.length === 12 && digits.startsWith("91")) return "+" + digits;
  return digits.length >= 8 && digits.length <= 15 ? "+" + digits : null;
}

/** +91 98110 44821 · +44 79111 23456: the country code apart, the rest in two halves. */
export function fmtPhone(e164: string | null | undefined): string {
  if (!e164) return "—";
  const m = /^\+91(\d{5})(\d{5})$/.exec(e164);
  if (m) return `+91 ${m[1]} ${m[2]}`;
  const parts = splitPhone(e164);
  const digits = parts?.national.replace(/\D/g, "");
  if (!parts || !digits || digits.length < 6) return e164;
  const half = Math.ceil(digits.length / 2);
  return `+${parts.country.dial} ${digits.slice(0, half)} ${digits.slice(half)}`;
}
